import React, { useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import EditIcon from "../../../Assets/images/edit.svg";
import Header from "../../../Components/Header/Header";
import ManageUserModal from "../../../Components/Modal/Customer/Add/Add";
import OrderhistoryCard from "../../../Components/OrderhistoryCard/OrderhistoryCard";
import SwitchBox from "../../../Components/FormControl/SwitchBox/SwitchBox";
import { AppContext } from "../../../Context/AppContext";
import { DEFAULT_COUNTRY_CODE, MODULES, PAYMENT_METHODS } from "../../../Helpers/Constants";
import { getAccessByModuleName } from "../../../Routes/Routes";
import CustomersApi from "../../../Services/Customers/Customers";
import styles from "./index.module.scss";
import { formatUsPhone,checkValidEmailId } from "../../../Hooks/commanUtility";
import PetalRewards from "./petalRewards";
import PetalRewardsForm from "./petalRewardsForm";
import LoadingScreen from "Components/Loading/LoadingScreen";
import PaymentCardApi from "Services/PaymentCard/PaymentCard";
import PaymentHistoryCard from "Components/PaymentHistoryCard/PaymentHistoryCard";
import PayabliPaymentCardEditModal from "Components/Modal/PayabliPaymentCardEdit/payabliPaymentCardEdit";
import Warning from "Components/Modal/Warning/warning";
import { updateCustomerFraud } from "api/customer";

const CustomerDetail = () => {
  const { showToastMessage, modules, setIsLoading } = useContext(AppContext);
  const [userDetails, setUserDetails] = useState(null);
  const [paymentCardDetails, setPaymentCardDetails] = useState(null);
  const [modalPaymentData, setmodalPaymentData] = useState(null);
  const [showFraudModal, setShowFraudModal] = useState(false);
  const [showUnFraudModal, setShowUnFraudModal] = useState(false);

  // const [userdetailsGet, setUserdetailsGet] = useState(false);

  // Add / Edit
  const [firstName, setFirstName] = useState(null);
  const [lastName, setLastName] = useState(null);
  const [email, setEmail] = useState(null);
  const [phone1, setPhone1] = useState(null);
  const [countryCode1, setCountryCode1] = useState(DEFAULT_COUNTRY_CODE);
  const [phone2, setPhone2] = useState(null);
  const [countryCode2, setCountryCode2] = useState(DEFAULT_COUNTRY_CODE);
  // const [address, setAddress] = useState(null);
  // const [city, setCity] = useState(null);
  // const [state, setState] = useState(null);
  // const [country, setCountry] = useState(null);
  // const [zipCode, setZipCode] = useState(null);
  const [uniqueAboutCustomer, setUniqueAboutCustomer] = useState(null);
  const [isHouseAccount, setIsHouseAccount] = useState(0);
  const [isBusinessAccount, setIsBusinessAccount] = useState(0) ;

  const [showAddModal, setShowAddModal] = useState(false);

  const [submitStatus, setSubmitStatus] = useState(false);
  const [manageUserPageTitle, setManageUserPageTitle] = useState("");

  const [access, setAccess] = useState({});
  const [newOrderAccess, setNewOrderAccess] = useState({});

  const [submitClick,setSubmitClick] = useState(false);


  const customersService = new CustomersApi();
  const paymentService = new PaymentCardApi();
  const navigate = useNavigate();
  const params = useParams();


  useEffect(() => {
    const checkModuleAccess = async()=>{
    let accountAccess = getAccessByModuleName(modules, MODULES.ACCOUNT_LOOKUP);
      if (accountAccess && accountAccess.permissions.write_access) {
        await handleGetUserData();
      }
    }
    checkModuleAccess();
  }, [params.id,submitClick]);

  /* Check Module Access */
  useEffect(getModuleAccess, [modules]);
  useEffect(()=>{
    handleGetPaymentCard();
  },[])
  const handleGetPaymentCard = async()=>{
    let selectedStore = localStorage.getItem("selectedStore");
    const getPaymentBody={
      id:params.id,
      selectedStore:selectedStore
    }
     await paymentService.getPaymentCardlist(getPaymentBody).then((data)=>{
      if (data && data.status === 200) {
        let cards = [...data.data.data.rows];
        cards = cards.filter((item, index, self) => index === self.findIndex((obj) => obj.last_4number === item.last_4number));
        setPaymentCardDetails(cards);
      } else {
        showToastMessage(undefined, data.data.data.message, "error", false);
      }
     }).catch((error)=>{
        showToastMessage(undefined, error.data.message, "error", false);
     })
  }

  const handleGetUserData = async () => {
    const { id } = params;
    if (!id) return;

    let selectedStore = localStorage.getItem("selectedStore");
    const postData = {
      id,
      selectedStore: selectedStore
    };
    await customersService
      .getCustomerWithOrderDetails(postData)
      .then((data) => {
        if (data && data.status === 200) {
          setUserDetails(data.data.data);
        } else {
          showToastMessage(undefined, data.data.message, "error", false);
        }
        setSubmitClick(false)
        // setLoading(false);
        // setUserdetailsGet(true);
      })
      .catch((err) => {
        showToastMessage(undefined, err.data.message, "error", false);
        // setUserdetailsGet(true);
      });
  };

  function getModuleAccess() {
    let access = getAccessByModuleName(modules, MODULES.ACCOUNT_LOOKUP);
    if (access) setAccess(access.permissions);
    if (access && !access.permissions.write_access) {
      showToastMessage(
        undefined,
        "You are not authorized to access.",
        "error",
        false
      );
      navigate(`/users`);
    }
    let newOrderAccess = getAccessByModuleName(modules, MODULES.NEW_ORDER);
    if (newOrderAccess) setNewOrderAccess(newOrderAccess.permissions);
  }

  const handleManageHeaderClick = async (event, link) => {
    event.preventDefault();

    window.location = link;
  };

  const handleSeeAllClick = async (event, link) => {
    event.preventDefault();
    navigate(link)

    // window.location = link;
  };

  const handleManageUserClick = async (event) => {
    event.preventDefault();

    setShowAddModal(true);
    setManageUserPageTitle("Edit Personal Information");
    setFirstName(userDetails.customer?.first_name);
    setLastName(userDetails.customer?.last_name);
    setEmail(userDetails.customer?.email);
    setPhone1(userDetails.customer?.phone);
    setCountryCode1(userDetails.customer?.country_code);
    setPhone2(userDetails.customer?.alt_phone);
    setCountryCode2(userDetails.customer?.alt_country_code);
    // setAddress(
    //   userDetails.customer && userDetails.customer.customer_cards.length
    //     ? userDetails.customer.customer_cards[0].address_line_1
    //     : ""
    // );
    // setCountry(
    //   userDetails.customer && userDetails.customer.customer_cards.length
    //     ? userDetails.customer.customer_cards[0].country
    //     : ""
    // );
    // setState(
    //   userDetails.customer && userDetails.customer.customer_cards.length
    //     ? userDetails.customer.customer_cards[0].state
    //     : ""
    // );
    // setCity(
    //   userDetails.customer && userDetails.customer.customer_cards.length
    //     ? userDetails.customer.customer_cards[0].city
    //     : ""
    // );
    // setZipCode(
    //   userDetails.customer && userDetails.customer.customer_cards.length
    //     ? userDetails.customer.customer_cards[0].zip_code
    //     : ""
    // );
    setUniqueAboutCustomer(userDetails.customer.unique_about_customer);
    setIsHouseAccount(userDetails.customer.is_house_account);
    setIsBusinessAccount(userDetails.customer.is_business_account)
  };

  const handleManageUser = async (event) => {
    event.preventDefault();
    setSubmitStatus(true);

    if (
      firstName?.trim() &&
      lastName?.trim() &&
      email?.trim() &&
      phone1?.trim()
      // address &&
      // city &&
      // country &&
      // state &&
      // zipCode &&
      // uniqueAboutCustomer?.trim()
    ) {
      if(!checkValidEmailId(email)){
        showToastMessage(
          undefined,
          "Please enter a valid email id",
          "error",
          false
        );
        return false;
      }

      let customer = {
        first_name: firstName,
        last_name: lastName,
        email: email,
        unique_about_customer: uniqueAboutCustomer,
        is_house_account: isHouseAccount,
        is_business_account: isBusinessAccount,
        phone: phone1,
        country_code: countryCode1,
        is_business_account: isBusinessAccount,
      };

      // if (phone2 && phone2 !== null) {
      customer["alt_phone"] = phone2;
      customer["alt_country_code"] = countryCode2;
      // }
      let reqBody = {
        customer: customer,
        // customer_cards: {
        //   address_line_1: address,
        //   country: country,
        //   state: state,
        //   city: city,
        //   zip_code: zipCode,
        // },
      };
      let response;
      if (userDetails.customer.id) {
        reqBody["id"] = userDetails.customer.id;
        response = await customersService.updateCustomer(reqBody);
      }

      if (response && response.status === 200) {
        showToastMessage(undefined, response.data.message, "success", false);
        setShowAddModal(false);
        setSubmitStatus(false);
        handleGetUserData();

        // Clear all value
        // setUserDetails({});
        setFirstName(null);
        setLastName(null);
        setEmail(null);
        setPhone1(null);
        setCountryCode1("+1");
        setPhone2(null);
        setCountryCode2("+1");
        // setAddress(null);
        // setCountry(null);
        // setState(null);
        // setCity(null);
        // setZipCode(null);
        setUniqueAboutCustomer(null);
        setIsHouseAccount(0);
        setIsBusinessAccount(0);
      } else {
        showToastMessage(undefined, response.data.message, "error", false);
      }
    } else {
      showToastMessage(
        undefined,
        "Please fill required information",
        "error",
        false
      );
    }
  };

  /**
   * Handles marking a customer as a fraud customer
   * This function is called when the user confirms the fraud customer action
   * @param {Event} event - The click event from the confirmation modal
   */
  const handleFraudCustomer = async (event) => {
    try {
      event.preventDefault();
      // Close the fraud confirmation modal
      setShowFraudModal(false);
      // Show loading indicator while processing the request
      setIsLoading(true);
      
      // Prepare the data payload for the API call
      const postData = {
        id: userDetails.customer.id,
        is_fraud_customer: 1, // Set fraud flag to true (1)
      }
      
      // Call the API to update customer fraud status
      const markFraudCustomer = await updateCustomerFraud(postData);
      
      // Handle successful response
      if(markFraudCustomer && markFraudCustomer.status === 200){
        // Show success message to user
        showToastMessage(undefined, markFraudCustomer.data.message, "success", false);
        // Refresh user data to reflect the updated fraud status
        handleGetUserData();
        setIsLoading(false);
      } else {
        // Handle API error response
        showToastMessage(undefined, markFraudCustomer.data.message, "error", false);
        setIsLoading(false);
      }
    } catch (error) {
      // Handle unexpected errors (network issues, etc.)
      setIsLoading(false);
      showToastMessage(undefined, "Something went wrong!", "error", false);
    }
  };

  /**
   * Handles removing the fraud status from a customer
   * This function is called when the user confirms the un-fraud customer action
   * @param {Event} event - The click event from the confirmation modal
   */
  const handleUnFraudCustomer = async (event) => {    
    try {
      event.preventDefault();
      // Close the un-fraud confirmation modal
      setShowUnFraudModal(false);
      // Show loading indicator while processing the request
      setIsLoading(true);
      
      // Prepare the data payload for the API call
      const postData = {
        id: userDetails.customer.id,
        is_fraud_customer: 0, // Set fraud flag to false (0)
      }
      
      // Call the API to update customer fraud status
      const markUnFraudCustomer = await updateCustomerFraud(postData);
      
      // Handle successful response
      if(markUnFraudCustomer && markUnFraudCustomer.status === 200){
        // Show success message to user
        showToastMessage(undefined, markUnFraudCustomer.data.message, "success", false);
        // Refresh user data to reflect the updated fraud status
        handleGetUserData();
        setIsLoading(false);
      } else {
        // Handle API error response
        showToastMessage(undefined, markUnFraudCustomer.data.message, "error", false);
        setIsLoading(false);
      }
    } catch (error) {
      // Handle unexpected errors (network issues, etc.)
      setIsLoading(false);
      showToastMessage(undefined, "Something went wrong!", "error", 0);
    }
  };

  if (!userDetails) return <LoadingScreen />;

  return (
    <React.Fragment>
      <Header
        title={`Account Lookup ${
          userDetails.customer
            ? "- " +
              userDetails.customer.first_name +
              " " +
              userDetails.customer.last_name
            : ""
        }`}
        hasCreateOrderButton={newOrderAccess.write_access}
        isDisabledCreateOrderButton={!!userDetails.customer.is_fraud_customer}
        handleCreateOrderClick={(e) =>
          handleManageHeaderClick(
            e,
            `/admin/orders/new-order/${userDetails.customer.id}`
          )
        }
        hasFraudOrderButton={!userDetails.customer.is_fraud_customer}
        hasUnFraudOrderButton={!!userDetails.customer.is_fraud_customer}
        handleFraudOrderClick={(e) => {
          e.preventDefault();
          setShowFraudModal(true);
        }}
        handleUnFraudOrderClick={(e) => {
          e.preventDefault();
          setShowUnFraudModal(true);
        }}
      />

      {/* Fraud Customer Modal */}
      {showFraudModal && (
        <Warning
          btn1_title={"Continue"}
          btn2_title={"Cancel"}
          handleCancelClick={() => setShowFraudModal(false)}
          showModal={showFraudModal}
          handleSubmitClick={handleFraudCustomer}
          title={"Mark as Fraud Customer"}
          message={ "Are you sure you want to mark this customer as a fraud customer?"}
          key={"fraud_customer_warning"}
        />
      )}

      {/* UnFraud Customer Modal */}
      {showUnFraudModal && (
        <Warning
          btn1_title={"Continue"}
          btn2_title={"Cancel"}
          handleCancelClick={() => setShowUnFraudModal(false)}
          showModal={showUnFraudModal}
          handleSubmitClick={handleUnFraudCustomer}
        title={"Mark as Un-Fraud Customer"}
        message={ "Are you sure you want to mark this customer as a Un-Fraud customer?"}
          key={"un_fraud_customer_warning"}
        />
      )}

      {access.read_access && (
        <div id="MainContent" className="main-content">
          <div className="container-fluid">
            <h3 className="bold mt-5 mb-3 d-flex align-items-center">
              <span>Personal Information</span>
              <span
                onClick={handleManageUserClick}
                className={`cursor-pointer ml-1 mb-1`}
                
                
              >
                <img className={styles.icon} src={EditIcon} alt="" />
              </span>
            </h3>
            <div className="row">
              <div className={`col-12 col-lg-3 mb-4`}>
                <div className={`${styles.PersonalInformationLabel}`}>
                  First Name
                </div>
                <div className={`${styles.PersonalInformationDetail}`}>
                  {userDetails.customer &&
                  userDetails.customer.first_name !== null
                    ? userDetails.customer.first_name
                    : "-"}
                </div>
              </div>
              <div className={`col-12 col-lg-3 mb-4`}>
                <div className={`${styles.PersonalInformationLabel}`}>
                  Last Name
                </div>
                <div className={`${styles.PersonalInformationDetail}`}>
                  {userDetails.customer &&
                  userDetails.customer.last_name !== null
                    ? userDetails.customer.last_name
                    : "-"}
                </div>
              </div>
              <div className={`col-12 col-lg-6 mb-4`}>
                <div className={`${styles.PersonalInformationLabel}`}>
                  Email
                </div>
                <div className={`${styles.PersonalInformationDetail}`}>
                  {userDetails.customer && userDetails.customer.email !== null
                    ? userDetails.customer.email
                    : "-"}
                </div>
              </div>
              <div className={`col-12 col-lg-3 mb-4`}>
                <div className={`${styles.PersonalInformationLabel}`}>
                  Phone 1
                </div>
                <div className={`${styles.PersonalInformationDetail}`}>
                  {userDetails.customer && userDetails.customer?.phone
                    ? userDetails.customer?.country_code +
                      " " +
                      formatUsPhone(userDetails.customer.phone)
                    : "-"}
                </div>
              </div>
              <div className={`col-12 col-lg-3 mb-4`}>
                <div className={`${styles.PersonalInformationLabel}`}>
                  Phone 2
                </div>
                <div className={`${styles.PersonalInformationDetail}`}>
                  {userDetails.customer && userDetails.customer?.alt_phone
                    ? userDetails.customer?.alt_country_code +
                      " " +
                      formatUsPhone(userDetails.customer.alt_phone)
                    : "-"}
                </div>
              </div>
              {/* <div className={`col-12 col-lg-6 mb-4`}>
                <div className={`${styles.PersonalInformationLabel}`}>
                  Address
                </div>
                <div className={`${styles.PersonalInformationDetail}`}>
                  {userDetails.customer &&
                  userDetails.customer.customer_cards.length
                    ? userDetails.customer.customer_cards[0].zip_code
                      ? `${userDetails.customer.customer_cards[0].customer_address} - ${userDetails.customer.customer_cards[0].zip_code}`
                      : `${userDetails.customer.customer_cards[0].customer_address}`
                    : "-"}
                </div>
              </div> */}
              <div className={`col-12 col-lg-3 mb-4`}>
                <div className={`${styles.PersonalInformationLabel}`}>
                  House Account
                </div>
                <div className={`${styles.PersonalInformationDetail}`}>
                  <SwitchBox
                    value={
                      userDetails.customer
                        ? userDetails.customer.is_house_account
                        : 0
                    }
                    disabled={true}
                  />
                </div>
              </div>
              <div className={`col-12 col-lg-3 mb-4`}>
                <div className={`${styles.PersonalInformationLabel}`}>
                  Business Account
                </div>
                <div className={`${styles.PersonalInformationDetail}`}>
                  <SwitchBox
                    value={
                      userDetails.customer
                        ? userDetails.customer.is_business_account
                        : 0
                    }
                    disabled={true}
                  />
                </div>
              </div>
              <div className={`col-12 col-lg-9 mb-8`}>
                <div className={`${styles.PersonalInformationLabel}`}>
                  What's unique about this customer?
                </div>
                <div className={`${styles.PersonalInformationDetail}`}>
                  {userDetails.customer
                    ? userDetails.customer.unique_about_customer
                    : "-"}
                </div>
              </div>
            </div>
            <h3 className="bold mt-5 mb-4">Summary</h3>
            {/* <div className="row"> */}
            <div className={`${styles.OrderSummaryCard}`}>
              <div className="row">
                <div
                  className={`${styles.OrderSummaryItem} col-12 col-lg-3 col-sm-12 col-xs-12`}
                >
                  <div className={`${styles.OrderSummaryDetail}`}>
                    {userDetails.total_orders}
                  </div>
                  <div className={`${styles.OrderSummaryLabel}`}>
                    Total Orders
                  </div>
                </div>
                <div
                  className={`${styles.OrderSummaryItem} col-12 col-lg-3 col-sm-12 col-xs-12`}
                >
                  <div className={`${styles.OrderSummaryDetail}`}>
                    $
                    {userDetails.avg_order_value
                      ? userDetails.avg_order_value.toFixed(2)
                      : 0}
                  </div>
                  <div className={`${styles.OrderSummaryLabel}`}>
                    AVG Order Value
                  </div>
                </div>
                <div
                  className={`${styles.OrderSummaryItem} col-12 col-lg-3 col-sm-12 col-xs-12`}
                >
                  <div className={`${styles.OrderSummaryDetail}`}>
                    {userDetails.refunded_orders}
                  </div>
                  <div className={`${styles.OrderSummaryLabel}`}>
                    Refunded Orders
                  </div>
                </div>
                <div
                  className={`${styles.OrderSummaryItem} col-12 col-lg-3 col-sm-12 col-xs-12`}
                >
                  <div className={`${styles.OrderSummaryDetail}`}>
                    {userDetails.replaced_orders}
                  </div>
                  <div className={`${styles.OrderSummaryLabel}`}>
                    Replaced Orders
                  </div>
                </div>
              </div>
            </div>
            {/* </div> */}
            <h3 className="bold mt-5 mb-2">
              Order History
              <span
                className={`cursor-pointer ${styles.SeeAllLink}`}
                onClick={(e) =>
                  handleSeeAllClick(
                    e,
                    `/admin/orders/list/${userDetails.customer.id}/${
                      userDetails.customer
                        ? userDetails.customer.first_name +
                          " " +
                          userDetails.customer.last_name
                        : ""
                    }`
                  )
                }
              >
                See All
              </span>
            </h3>
            <div className="row">
              {userDetails.customer_orders &&
              userDetails.customer_orders.length > 0
                ? userDetails.customer_orders.map((data, index) => {
                    let card_data = {
                      orderId: data.order_number,
                      id: data.id,
                      price: data.total,
                      orderStatus: data.order_status,
                      // date: data.createdAt,
                      date: data.delivery_date_time,
                      refundAmount:
                        data.refund && data.refund !== null ? data.refund : 0,
                    };

                    let recipients_data = [];
                    data.order_recipients.map((recipient) => {
                      recipients_data.push(recipient.first_name);
                      return recipients_data;
                    });
                    card_data.name = recipients_data.join(", ");

                    return (
                      <div key={card_data.id || index} className={`col-12 col-lg-3 col-md-3 col-sm-12 col-xs-12 pt-3 pb-3 ${styles.OrderHistoryWrapper}`}
                      >
                        <OrderhistoryCard key={index} data={card_data} />
                      </div>
                    );
                  })
                : ""}
            </div>
            <h3 className="bold mt-5 mb-2">
              Payment Methods
            </h3>
            <div className="row">
              {paymentCardDetails &&
              paymentCardDetails.length > 0
                ? paymentCardDetails.map((data, index) => {
                    return (
                      <div key={data.id || index} className={`col-12 col-lg-3 col-md-3 col-sm-12 col-xs-12 pt-3 pb-3 ${styles.OrderHistoryWrapper}`}
                      >
                        <PaymentHistoryCard key={index} data={data}/>
                      </div>
                    );
                  })
                :<p className="col-12 pt-4" style={{fontSize:"18px",lineHeight:"24px",fontWeight:"500",textAlign:"center"}}>No Payment Method Found</p>}
            </div>
            <h3 className="bold mt-5 mb-2">Petal Rewards</h3>
            {userDetails && (
              <PetalRewardsForm
                userDetails={userDetails}
                onSubmitClick={(data)=>setSubmitClick(data)}
                // customerId={userDetails.customer && userDetails.customer.id ? userDetails.customer.id : 0}
                // customerName={userDetails.customer && userDetails.customer.first_name ? userDetails.customer.first_name : "-"}
                // petal_amount={userDetails.customer && userDetails.customer.petal_rewards.length>0 && userDetails.customer.petal_rewards[0].total_amounts ? userDetails.customer.petal_rewards[0].total_amounts : 0}
                // petal_point={userDetails.customer && userDetails.customer.petal_rewards.length>0 && userDetails.customer.petal_rewards[0].total_points ? userDetails.customer.petal_rewards[0].total_points : 0}
              />
            )}
            <PetalRewards userDetails={userDetails} />
            <h3 className="bold mt-5 mb-2">&nbsp;</h3>
          </div>
        </div>
      )}

      {access.write_access && (
        <ManageUserModal
          showModal={showAddModal}
          pageTitle={manageUserPageTitle}
          firstName={firstName}
          lastName={lastName}
          email={email}
          phone1={phone1}
          countryCode1={countryCode1}
          phone2={phone2}
          countryCode2={countryCode2}
          // address={address}
          // city={city}
          // state={state}
          // country={country}
          // zipCode={zipCode}
          uniqueAboutCustomer={uniqueAboutCustomer}
          isHouseAccount={isHouseAccount}
          isBusinessAccount={isBusinessAccount}
          submitStatus={submitStatus}
          handleCancelClick={(e) => {
            setShowAddModal(false);
            // Clear all value
            setFirstName(null);
            setLastName(null);
            setEmail(null);
            setPhone1(null);
            setCountryCode1("+1");
            setPhone2(null);
            setCountryCode2("+1");
            // setAddress(null);
            // setCity(null);
            // setState(null);
            // setCountry(null);
            // setZipCode(null);
            setUniqueAboutCustomer(null);
            setIsHouseAccount(0);
            setIsBusinessAccount(0);
          }}
          handleSubmitClick={handleManageUser}
          onChange={(type, data) => {
            if (type === "firstName") setFirstName(data);
            if (type === "lastName") setLastName(data);
            if (type === "email") setEmail(data);
            if (type === "phone1") setPhone1(data);
            if (type === "countryCode1") setCountryCode1(data);
            if (type === "phone2") setPhone2(data);
            if (type === "countryCode2") setCountryCode2(data);
            // if (type === "address") setAddress(data);
            // if (type === "city") setCity(data);
            // if (type === "state") setState(data);
            // if (type === "country") setCountry(data);
            // if (type === "zipCode") setZipCode(data);
            if (type === "uniqueAboutCustomer") setUniqueAboutCustomer(data);
            if (type === "isHouseAccount") setIsHouseAccount(data);
            if (type === "isBusinessAccount") setIsBusinessAccount(data);
          }}
          onBlur={(type, data) => {
            if (type === "firstName") setFirstName(data?.trim());
            if (type === "lastName") setLastName(data);
            if (type === "email") setEmail(data);
            if (type === "phone1") setPhone1(data);
            if (type === "countryCode1") setCountryCode1(data);
            if (type === "phone2") setPhone2(data);
            if (type === "countryCode2") setCountryCode2(data);
            // if (type === "address") setAddress(data);
            // if (type === "city") setCity(data);
            // if (type === "state") setState(data);
            // if (type === "country") setCountry(data);
            // if (type === "zipCode") setZipCode(data);
            if (type === "uniqueAboutCustomer") setUniqueAboutCustomer(data);
            if (type === "isHouseAccount") setIsHouseAccount(data);
            if (type === "isBusinessAccount") setIsBusinessAccount(data);
          }}
        />
      )}
    </React.Fragment>
  );
};

export default CustomerDetail;
